import React from 'react';
import { Typography, Layout, Divider, Table, List } from 'antd';

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

const TermsEN = () => {


  return (
    <Layout style={{ padding: '40px 20px' }}>
      <Content style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <Typography>
          <Title level={2} style={{ textAlign: 'center' }}>TERMS AND CONDITIONS OF USE</Title>
          <Title level={3} style={{ textAlign: 'center' }}>“MusicTMM-Universum” Web and Mobile Application</Title>
          <Paragraph style={{ textAlign: 'center' }}>
            <Text strong>Effective date: February 11, 2025</Text>
          </Paragraph>

          <Divider />

          <Title level={4}>1. PUBLISHER IDENTIFICATION</Title>
          <Paragraph>
            The “MusicTMM-Universum” web and mobile platform (hereinafter the “Platform”) is published by:
          </Paragraph>
          <Paragraph style={{ paddingLeft: '20px' }}>
            <Text strong>MusicTMM SAS</Text><br />
            Simplified joint stock company<br />
            Head office: 99 Avenue Achille Peretti, 92200 Neuilly-sur-Seine, France<br />
            Email: hello@musictmm.fr
          </Paragraph>
          <Paragraph>
            The Company owns the intellectual property rights relating to the Platform.
          </Paragraph>

          <Title level={4}>2. PURPOSE</Title>
          <Paragraph>
            The purpose of these Terms and Conditions of Use (hereinafter the “TCU”) is to define the conditions under which the Company grants professional users (hereinafter the “Customer”) the right to access and use the Platform.
          </Paragraph>
          <Paragraph>
            The TCU constitute a contract within the meaning of Articles 1101 et seq. of the Civil Code.
          </Paragraph>
          <Paragraph>
            The Platform is strictly reserved for legal entities or professionals acting within the scope of their commercial activity.
          </Paragraph>

          <Title level={4}>3. ACCEPTANCE</Title>
          <Paragraph>
            Access to and use of the Platform implies unreserved acceptance of these GTCU.
          </Paragraph>
          <Paragraph>
            The Customer declares that they:
          </Paragraph>
          <ul>
            <li>are acting for professional purposes;</li>
            <li>have the necessary legal capacity and powers;</li>
            <li>are providing accurate and up-to-date information.</li>
          </ul>

          <Title level={4}>4. DESCRIPTION OF SERVICES</Title>
          <Paragraph>
            The Platform allows, in particular:
          </Paragraph>
          <ul>
            <li>the distribution and management of musical content in commercial spaces;</li>
            <li>access to editorial or artificial intelligence-assisted playlists;</li>
            <li>the administration of professional accounts.</li>
          </ul>
          <Paragraph>
            The Company reserves the right to change the features at any time, subject to informing the Customer in the event of a substantial change.
          </Paragraph>

          <Title level={4}>5. LICENSE OF USE</Title>
          <Paragraph>
            The Company grants the Customer a license that is:
          </Paragraph>
          <ul>
            <li>non-exclusive</li>
            <li>non-assignable</li>
            <li>non-transferable</li>
            <li>limited to the term of the contract</li>
          </ul>
          <Paragraph>
            The license authorizes only:
          </Paragraph>
          <ul>
            <li>access to the Platform;</li>
            <li>use of musical content in accordance with its professional purpose.</li>
          </ul>
          <Paragraph>
            Any unauthorized reproduction, extraction, reverse engineering, scraping, or exploitation is strictly prohibited.
          </Paragraph>
          <Paragraph>
            The Platform's database is protected in accordance with Directive 96/9/EC.
          </Paragraph>
          <Paragraph>
            Registration on the Platform does not confer any right to use the Service.
          </Paragraph>
          <Paragraph>
            Effective access to the Service is subject to the signing of a separate commercial contract between MusicTMM SAS and the Customer.
          </Paragraph>
          <Paragraph>
            Access to the Platform, including the use of the content made available, does not in any way exempt the Customer from their legal obligations relating to the payment of royalties that may be due to collective management societies or organizations responsible for collecting copyright and related rights, in accordance with the regulations applicable in the territory of use.
          </Paragraph>
          <Paragraph>
            Access to the Service is provided for a fee under the terms and conditions set out in the separate commercial contract concluded between the Company and the Customer.
          </Paragraph>
          <Paragraph>
            The Terms of Use do not determine the applicable pricing conditions.
          </Paragraph>

          <Title level={4}>6. INTELLECTUAL PROPERTY</Title>
          <Paragraph>
            The Platform, its algorithms, architecture, content, trademarks, and databases remain the exclusive property of MusicTMM SAS.
          </Paragraph>
          <Paragraph>
            No transfer of intellectual property is made to the Customer.
          </Paragraph>

          <Title level={4}>7. CONTENT ASSISTED BY ARTIFICIAL INTELLIGENCE</Title>
          <Paragraph>
            Some audio content available on the Platform may include elements generated or assisted by artificial intelligence technologies, including synthetic voices, without this implying the imitation of an identified real artist.
          </Paragraph>
          <Paragraph>
            The Company ensures that it complies with the transparency requirements set out in the applicable European regulations on artificial intelligence.
          </Paragraph>

          <Title level={4}>8. PERSONAL DATA</Title>
          <Paragraph>
            The Company acts as Data Controller within the meaning of Regulation (EU) 2016/679 (GDPR).
          </Paragraph>
          <Paragraph>
            The data collected is processed for the purposes of:
          </Paragraph>
          <ul>
            <li>managing professional accounts;</li>
            <li>contractual performance;</li>
            <li>improving services;</li>
            <li>complying with legal obligations.</li>
          </ul>
          <Paragraph>
            The full terms and conditions are detailed in the Privacy Policy available on the official website.
          </Paragraph>

          <Title level={4}>9. CUSTOMER OBLIGATIONS</Title>
          <Paragraph>
            The Customer undertakes to:
          </Paragraph>
          <ul>
            <li>use the Platform in accordance with its professional purpose;</li>
            <li>not infringe the rights of the Company or third parties;</li>
            <li>ensure the security of their login details;</li>
            <li>inform the Company immediately of any fraudulent access.</li>
          </ul>
          <Paragraph>
            Any misuse may result in the immediate suspension of the service.
          </Paragraph>

          <Title level={4}>10. LIABILITY</Title>
          <Paragraph>
            The Company is bound by an obligation of means.
          </Paragraph>
          <Paragraph>
            The Company shall not be held liable for:
          </Paragraph>
          <ul>
            <li>indirect losses;</li>
            <li>operating losses;</li>
            <li>loss of earnings;</li>
            <li>damage to image.</li>
          </ul>
          <Paragraph>
            The Company's total liability is limited to the amount actually paid by the Customer during the last twelve (12) months.
          </Paragraph>
          <Paragraph>
            This limitation also applies to the appendices, including the SLA.
          </Paragraph>
          <Paragraph>
            This limitation does not apply in the event of gross negligence or wilful misconduct.
          </Paragraph>

          <Title level={4}>11. AVAILABILITY</Title>
          <Paragraph>
            The Company strives to ensure reasonable availability of the Platform.
          </Paragraph>
          <Paragraph>
            No guarantee of uninterrupted operation is provided.
          </Paragraph>

          <Title level={4}>12. MODIFICATION OF THE TERMS OF USE</Title>
          <Paragraph>
            The Company may modify these Terms of Use.
          </Paragraph>
          <Paragraph>
            Any substantial modification will be notified to the Customer within a reasonable period of time.
          </Paragraph>
          <Paragraph>
            In the event of disagreement, the Customer may terminate their contract.
          </Paragraph>

          <Title level={4}>13. TERM AND TERMINATION</Title>
          <Paragraph>
            The Terms of Use apply for the duration of use of the services.
          </Paragraph>
          <Paragraph>
            In the event of a serious breach, the Company may suspend or terminate access after formal notice has remained without effect.
          </Paragraph>

          <Title level={4}>14. ASSIGNMENT</Title>
          <Paragraph>
            The Company may assign all or part of its rights and obligations to any entity within its group or as part of a restructuring, merger, or acquisition.
          </Paragraph>

          <Title level={4}>15. APPLICABLE LAW AND JURISDICTION</Title>
          <Paragraph>
            These Terms of Use are governed by French law.
          </Paragraph>
          <Paragraph>
            Any dispute relating to their interpretation or execution shall fall within the exclusive jurisdiction of the courts of Paris.
          </Paragraph>

          <Title level={4}>16. FORCE MAJEURE</Title>
          <Paragraph>
            Neither party shall be held liable for any breach resulting from a case of force majeure within the meaning of Article 1218 of the Civil Code.
          </Paragraph>

          <Title level={4}>17. FINAL PROVISIONS</Title>
          <Paragraph>
            If any clause is declared invalid, the other provisions shall remain applicable.
          </Paragraph>
          <Paragraph>
            The Terms of Use constitute the entire agreement between the parties.
          </Paragraph>

          <Divider style={{ borderWidth: '2px', borderColor: '#000' }} />

          <Title level={2} style={{ textAlign: 'center' }}>APPENDIX 1 – SERVICE LEVEL AGREEMENT (SLA)</Title>
          <Paragraph style={{ textAlign: 'center' }}>
            <Text strong>Effective date: February 11, 2025</Text>
          </Paragraph>
          <Paragraph style={{ textAlign: 'center' }}>
            Applicable to the “MusicTMM-Universum” Platform
          </Paragraph>

          <Title level={4}>1. PURPOSE</Title>
          <Paragraph>
            This Appendix defines the Service Level Commitments applicable to the “MusicTMM-Universum” SaaS platform operated by MusicTMM SAS (hereinafter the “Company”).
          </Paragraph>
          <Paragraph>
            It specifies:
          </Paragraph>
          <ul>
            <li>availability levels;</li>
            <li>support terms and conditions;</li>
            <li>response times;</li>
            <li>exclusions;</li>
            <li>possible compensation.</li>
          </ul>

          <Title level={4}>2. DEFINITIONS</Title>
          <Paragraph>
            <Text strong>Service</Text> : access to the web and mobile platform enabling the distribution and management of music content in a professional environment.
          </Paragraph>
          <Paragraph>
            <Text strong>Incident</Text> : malfunction preventing or significantly impairing the normal use of the Service.
          </Paragraph>
          <Paragraph>
            <Text strong>Business hours</Text> : Monday to Friday, 9:00 a.m. to 6:00 p.m. (Paris time), excluding French public holidays.
          </Paragraph>

          <Title level={4}>3. SERVICE AVAILABILITY</Title>
          <Title level={5}>3.1 Availability commitment</Title>
          <Paragraph>
            The Company undertakes to ensure monthly availability of the Service of:
          </Paragraph>
          <ul>
            <li>99% on a monthly basis</li>
          </ul>
          <Paragraph>
            Availability is calculated as follows:
          </Paragraph>
          <Paragraph style={{ textAlign: 'center', padding: '10px' }}>
            Availability (%) = [(Total monthly time – Unplanned downtime) / Total monthly time] × 100
          </Paragraph>

          <Title level={5}>3.2 Exclusions</Title>
          <Paragraph>
            The following are not considered downtime:
          </Paragraph>
          <ul>
            <li>scheduled maintenance notified at least 24 hours in advance;</li>
            <li>cases of force majeure;</li>
            <li>failure of the Customer's internet network;</li>
            <li>incorrect configuration or defective hardware on the part of the Customer;</li>
            <li>interruption related to a third party (host, cloud provider, etc.).</li>
          </ul>

          <Title level={4}>4. MAINTENANCE</Title>
          <Paragraph>
            The Company may carry out:
          </Paragraph>
          <Paragraph>
            <Text strong>Scheduled maintenance</Text>
          </Paragraph>
          <ul>
            <li>carried out outside business hours as far as possible;</li>
            <li>prior notification by email or via the platform.</li>
          </ul>
          <Paragraph>
            <Text strong>Corrective maintenance</Text>
          </Paragraph>
          <ul>
            <li>intervention as soon as a critical incident is detected.</li>
          </ul>

          <Title level={4}>5. TECHNICAL SUPPORT</Title>
          <Paragraph>
            Support is available via:
          </Paragraph>
          <ul>
            <li>email: hello@musictmm.fr</li>
            <li>administration interface (ticketing if available)</li>
          </ul>

          <Title level={4}>6. INCIDENT LEVELS AND RESPONSE TIMES</Title>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '1em' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>Level</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Description</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Response time</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Resolution target</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '12px' }}><Text strong>Critical (P1)</Text></td>
                <td style={{ padding: '12px' }}>Total interruption of the broadcasting service</td>
                <td style={{ padding: '12px' }}>4 business hours</td>
                <td style={{ padding: '12px' }}>24 hours</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '12px' }}><Text strong>Major (P2)</Text></td>
                <td style={{ padding: '12px' }}>Impaired operation without total interruption</td>
                <td style={{ padding: '12px' }}>1 business day</td>
                <td style={{ padding: '12px' }}>3 business days</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '12px' }}><Text strong>Minor (P3)</Text></td>
                <td style={{ padding: '12px' }}>Non-blocking malfunction</td>
                <td style={{ padding: '12px' }}>2 business days</td>
                <td style={{ padding: '12px' }}>Planned corrective action</td>
              </tr>
            </tbody>
          </table>
          <Paragraph>
            The deadlines are targets and not obligations of result.
          </Paragraph>

          <Title level={4}>7. CUSTOMER OBLIGATIONS</Title>
          <Paragraph>
            The Customer undertakes to:
          </Paragraph>
          <ul>
            <li>maintain a stable internet connection;</li>
            <li>use compatible equipment;</li>
            <li>report any incidents without delay;</li>
            <li>cooperate reasonably with the Company.</li>
          </ul>

          <Title level={4}>8. SECURITY</Title>
          <Paragraph>
            The Company implements reasonable technical and organizational measures to ensure:
          </Paragraph>
          <ul>
            <li>data security;</li>
            <li>protection against unauthorized access;</li>
            <li>business continuity.</li>
          </ul>
          <Paragraph>
            However, the Company is bound by an obligation of means.
          </Paragraph>

          <Title level={4}>9. EVOLUTION OF THE SLA</Title>
          <Paragraph>
            The Company may amend this SLA to adapt it to technological or regulatory developments.
          </Paragraph>
          <Paragraph>
            Any substantial changes will be notified in advance.
          </Paragraph>

          <Title level={4}>10. EXCLUSION OF INDIRECT LIABILITY</Title>
          <Paragraph>
            The Company shall not be held liable for any indirect losses, operating losses, or damage to its image resulting from an interruption of the Service.
          </Paragraph>

          <Title level={2} style={{ textAlign: 'center' }}>APPENDIX 2 – COPYRIGHT AND RELATED RIGHTS</Title>
          <Paragraph style={{ textAlign: 'center' }}>
            <Text strong>Effective date: February 11, 2025</Text>
          </Paragraph>
          <Paragraph style={{ textAlign: 'center' }}>
            Direct license model – MusicTMM
          </Paragraph>

          <Title level={4}>1. PURPOSE</Title>
          <Paragraph>
            The purpose of this Appendix is to specify the regime applicable to copyright and related rights relating to musical content distributed via the “MusicTMM-Universum” platform.
          </Paragraph>

          <Title level={4}>2. COPYRIGHT – DIRECT LICENSE</Title>
          <Paragraph>
            The musical content made available on the Platform is:
          </Paragraph>
          <ul>
            <li>either works for which MusicTMM SAS directly holds the economic exploitation rights;</li>
            <li>or works exploited under direct license agreements concluded with the rights holders.</li>
          </ul>
          <Paragraph>
            As of the date hereof, these works are not entrusted to collective management organizations for the management of copyrights relating to their distribution via the Platform.
          </Paragraph>
          <Paragraph>
            Consequently:
          </Paragraph>
          <ul>
            <li>The Customer shall pay MusicTMM SAS the remuneration corresponding to the copyright included in the subscription or the applicable contractual billing.</li>
            <li>Subject to compliance with the Terms of Use and the commercial contract, no additional declaration or payment of copyright fees to collective management organizations is required for the distribution of works provided exclusively via the Platform.</li>
          </ul>

          <Title level={4}>3. LIMITATION OF SCOPE</Title>
          <Paragraph>
            The copyright coverage referred to in Article 2 is strictly limited to:
          </Paragraph>
          <ul>
            <li>works actually made available by MusicTMM SAS;</li>
            <li>their distribution via the Platform;</li>
            <li>the professional use declared by the Customer.</li>
          </ul>
          <Paragraph>
            Any distribution of third-party works outside the Platform remains the sole responsibility of the Customer.
          </Paragraph>

          <Title level={4}>4. RELATED RIGHTS – INTERNATIONAL REGIME AND FAIR REMUNERATION</Title>
          <Paragraph>
            MusicTMM SAS declares that it controls, directly or contractually, the related rights relating to the phonograms made available on the Platform.
          </Paragraph>
          <Paragraph>
            However, the regulations applicable to related rights, and in particular to the mechanism of fair remuneration for the communication to the public of phonograms, vary according to jurisdiction.
          </Paragraph>
          <Paragraph>
            In certain jurisdictions, companies responsible for managing or collecting equitable remuneration for performers and producers may, depending on the applicable regulations, claim payment of a royalty, regardless of whether there is collective management of neighboring rights for the works concerned.
          </Paragraph>
          <Paragraph>
            Consequently:
          </Paragraph>
          <ul>
            <li>any obligations to declare and pay equitable remuneration for communication to the public may depend on the country in which the broadcast is made;</li>
            <li>unless specifically stipulated otherwise in a contract, the Customer remains responsible for complying with the local obligations applicable in the country of exploitation.</li>
          </ul>
          <Paragraph>
            In order to determine whether a reporting or payment obligation is applicable in the territory concerned, the Customer is invited to contact the Company at the following address:
            <br />
            <Text strong>hello@musictmm.fr</Text>
          </Paragraph>

          <Title level={4}>5. MUSIC TMM GUARANTEES</Title>
          <Paragraph>
            MusicTMM SAS declares that it has the necessary rights to make the works included in the Platform available under the direct license described in Article 2.
          </Paragraph>
          <Paragraph>
            The Company guarantees the Customer against any action based on copyright infringement concerning the works provided via the Platform, subject to:
          </Paragraph>
          <ul>
            <li>strict compliance with the contractual conditions;</li>
            <li>the absence of any modification, extraction, or unauthorized use of the content.</li>
          </ul>

          <Title level={4}>6. LEGAL QUALIFICATION</Title>
          <Paragraph>
            The parties acknowledge that MusicTMM SAS acts:
          </Paragraph>
          <ul>
            <li>as a provider of music content under direct license;</li>
            <li>as a SaaS platform operator.</li>
          </ul>
          <Paragraph>
            The Company does not act as a collective management organization or as an operator of an establishment broadcasting to the public.
          </Paragraph>

          <Title level={4}>7. REGULATORY CHANGES</Title>
          <Paragraph>
            In the event of legislative or regulatory changes affecting the regime applicable to copyright or related rights, the parties agree to adapt their contractual relations in good faith.
          </Paragraph>

          <Divider style={{ borderWidth: '2px', borderColor: '#000' }} />

          <Title level={2} style={{ textAlign: 'center' }}>APPENDIX 3 - PRIVACY POLICY</Title>
          <Paragraph style={{ textAlign: 'center' }}>
            MusicTMM SAS<br />
            <Text strong>Effective date: February 11, 2025</Text>
          </Paragraph>

          <Title level={4}>1. IDENTITY OF THE DATA CONTROLLER</Title>
          <Paragraph>
            MusicTMM SAS<br />
            99 Avenue Achille Peretti<br />
            92200 Neuilly-sur-Seine<br />
            France<br />
            Email: hello@musictmm.fr
          </Paragraph>
          <Paragraph>
            MusicTMM SAS acts exclusively as the Data Controller for data collected in connection with the operation of the “MusicTMM-Universum” web and mobile platform.
          </Paragraph>
          <Paragraph>
            The Company operates strictly on a B2B basis and does not collect any data relating to the end customers of the establishments using the Platform.
          </Paragraph>

          <Title level={4}>2. CATEGORIES OF DATA PROCESSED</Title>
          <Title level={5}>2.1 Professional identification data</Title>
          <ul>
            <li>professional email address</li>
            <li>company name</li>
            <li>name of representative</li>
            <li>business address</li>
            <li>professional telephone number</li>
          </ul>
          <Title level={5}>2.2 Technical data</Title>
          <ul>
            <li>IP address</li>
            <li>device type and model</li>
            <li>operating system</li>
            <li>connection logs</li>
            <li>usage history</li>
          </ul>
          <Title level={5}>2.3 Location data</Title>
          <ul>
            <li>approximate location (country, city)</li>
          </ul>
          <Paragraph>
            No precise GPS data is collected without explicit consent.
          </Paragraph>
          <Paragraph>
            No sensitive data within the meaning of Article 9 of the GDPR is processed.
          </Paragraph>
          <Paragraph>
            No profiling or automated decision-making with legal effects is carried out.
          </Paragraph>

          <Title level={4}>3. PURPOSES AND LEGAL BASES</Title>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '1em' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>Purpose</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Legal basis</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '12px' }}>Customer account management</td>
                <td style={{ padding: '12px' }}>Performance of a contract (Art. 6.1.b GDPR)</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '12px' }}>Subscription management and billing</td>
                <td style={{ padding: '12px' }}>Legal obligation</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '12px' }}>Technical support</td>
                <td style={{ padding: '12px' }}>Legitimate interest</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '12px' }}>Security and prevention of abuse</td>
                <td style={{ padding: '12px' }}>Legitimate interest</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '12px' }}>Improvement of services</td>
                <td style={{ padding: '12px' }}>Legitimate interest</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '12px' }}>Compliance with regulatory obligations</td>
                <td style={{ padding: '12px' }}>Legal obligation</td>
              </tr>
            </tbody>
          </table>
          <Paragraph>
            The legitimate interests pursued include, in particular, the security of the Platform, fraud prevention, and continuous improvement of services.
          </Paragraph>
          <Paragraph>
            Where processing is based on legitimate interest, the data subject may object to it on grounds relating to their particular situation.
          </Paragraph>

          <Title level={4}>4. SUBCONTRACTORS</Title>
          <Paragraph>
            Certain data may be processed by technical service providers acting on behalf of MusicTMM SAS, including:
          </Paragraph>
          <ul>
            <li>cloud hosting providers located in the European Union;</li>
            <li>technical service providers;</li>
            <li>maintenance services.</li>
          </ul>
          <Paragraph>
            These service providers are bound by contracts in accordance with Article 28 of the GDPR.
          </Paragraph>
          <Paragraph>
            The list of subcontractors can be provided upon request.
          </Paragraph>

          <Title level={4}>5. INTERNATIONAL TRANSFERS</Title>
          <Paragraph>
            The data is hosted within the European Union.
          </Paragraph>
          <Paragraph>
            In the event of a transfer to a third country, this will be governed by appropriate safeguards, including:
          </Paragraph>
          <ul>
            <li>the standard contractual clauses adopted by the European Commission;</li>
            <li>or any other mechanism recognized as compliant with the GDPR.</li>
          </ul>

          <Title level={4}>6. RETENTION PERIOD</Title>
          <Paragraph>
            Data is retained:
          </Paragraph>
          <ul>
            <li>for the duration of the contractual relationship;</li>
            <li>then archived in accordance with applicable legal obligations (in particular accounting obligations);</li>
            <li>billing data is retained for ten (10) years;</li>
            <li>technical logs are retained for a maximum period of twelve (12) months;</li>
            <li>beyond that, the data is deleted or anonymized.</li>
          </ul>

          <Title level={4}>7. SECURITY</Title>
          <Paragraph>
            MusicTMM SAS implements appropriate technical and organizational measures, including:
          </Paragraph>
          <ul>
            <li>encryption of data in transit;</li>
            <li>restricted access control;</li>
            <li>access logging;</li>
            <li>regular backups.</li>
          </ul>
          <Paragraph>
            The Company is bound by an obligation of means.
          </Paragraph>

          <Title level={4}>8. RIGHTS OF DATA SUBJECTS</Title>
          <Paragraph>
            In accordance with the GDPR, all data subjects have the following rights:
          </Paragraph>
          <ul>
            <li>right of access</li>
            <li>right of rectification</li>
            <li>right to erasure</li>
            <li>right to restriction</li>
            <li>right to object</li>
            <li>right to portability</li>
          </ul>
          <Paragraph>
            Requests can be sent to: <Text strong>hello@musictmm.fr</Text>
          </Paragraph>
          <Paragraph>
            They will be processed within a maximum of one (1) month.
          </Paragraph>
          <Paragraph>
            In the event of a dispute, a complaint may be lodged with the CNIL (www.cnil.fr).
          </Paragraph>

          <Title level={4}>9. DATA BREACH</Title>
          <Paragraph>
            In the event of a personal data breach that may pose a risk to the rights and freedoms of individuals, MusicTMM SAS will notify the competent authority and, where applicable, the individuals concerned in accordance with Articles 33 and 34 of the GDPR.
          </Paragraph>

          <Title level={4}>10. CHANGES</Title>
          <Paragraph>
            This Policy may be updated at any time to reflect regulatory or technical developments.
          </Paragraph>
          <Paragraph>
            Any substantial changes will be notified via the Platform or by email.
          </Paragraph>
        </Typography>
      </Content>
    </Layout>
  );
};

export default TermsEN;